import { useSnackbar } from 'notistack';

export const useErrorToaster = () => {
  const { enqueueSnackbar } = useSnackbar();

  return error => {};
};
